/**
 * @module employmentStatus
 * @description A list of employmentStatus
 */

export const employmentStatus = [
	'temporary',
	'permanent',
	'indefinite',
	'terminated',
	'indefinite',
	'suspension',
] as const;
export type EmploymentStatus = (typeof employmentStatus)[number];
